/*
 Helper to retrieve image data from MDMS API image data format
 Mimics the rails ApplicationHelper.image_variations_url

 options: {
   screen: 'desktop-wide', // desired screen size
   resolution: 2,          // desired res (@2x, etc)
   prefix: 'thumb_'        // optional prefix
 }
 */

const defaultOptions = {
  screen: 'desktop-wide', // desired screen size
  resolution: 2, // desired res (@2x, etc)
  prefix: '', // optional prefix
};

function first(obj) {
  return obj[Object.keys(obj)[0]];
}

function imageVariationsUrlInternal(image, options, fallback) {
  options = { ...defaultOptions, ...options };
  const { screen } = options;
  const { resolution } = options;
  const { prefix } = options;

  const sizes = ['desktop-wide', 'desktop', 'tablet', 'mobile'];
  const screenIndex = sizes.indexOf(screen);
  if (image) {
    if (image.variations) {
      let variation_name = screen;
      variation_name += resolution.to_i == 2 ? '@2x' : '';
      variation_name = prefix + variation_name;
      const variation = image.variations[variation_name];
      if (variation) {
        return variation;
      }
      if (resolution == 2 && !fallback) {
        // try low res version
        return imageVariationsUrlInternal(image, { screen, resolution: 1, prefix }, true);
      }
      if (resolution == 1 && !fallback) {
        // try low res version
        return imageVariationsUrlInternal(image, { screen, resolution: 2, prefix }, true);
      }
      if (screenIndex !== -1) {
        // fallback to next lowest size
        const lower_size = sizes[screenIndex + 1];
        // try again at next lower size, or else return the first item
        return lower_size === undefined
          ? first(image.variations)
          : imageVariationsUrlInternal(image, { screen: lower_size, resolution: 2, prefix }, true);
      }
      // fallback if fails above
      return first(image.variations);
    }
    // fall back to non-variation URL (if any)
    return image.url;
  }
  // TODO: fallback url? in this case there was no image of the type...
  return null;
}

export default function imageVariationsUrl(image, options) {
  return imageVariationsUrlInternal(image, options, false);
}
